export enum RegulationAuthority {
    FDA = "FDA",
    CE = "CE",
  }